export const isAr = document.documentElement.lang === 'ar';
export const byId = (id) => document.getElementById(id);
export const message = (id, text, kind = 'info') => {
  const el = byId(id);
  if (!el) return;
  el.textContent = text;
  el.dataset.kind = kind;
};
export const formatBytes = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 ** 2).toFixed(2)} MB`;
};
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
export async function copyText(value) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const field = document.createElement('textarea');
  field.value = value;
  field.style.cssText = 'position:fixed;opacity:0;inset-inline-start:-9999px';
  document.body.append(field);
  field.select();
  const copied = document.execCommand('copy');
  field.remove();
  if (!copied) throw new Error('Clipboard unavailable');
}
export function showFileAdvisory(containerOrId, text, show = true) {
  const parent = typeof containerOrId === 'string' ? byId(containerOrId) : containerOrId;
  if (!parent) return null;
  let pill = parent.querySelector('.file-advisory-pill');
  if (!pill) {
    pill = document.createElement('div');
    pill.className = 'file-advisory-pill';
    pill.setAttribute('role', 'status');
    pill.setAttribute('aria-live', 'polite');
    pill.innerHTML = `
      <span class="file-advisory-icon" aria-hidden="true">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </span>
      <span class="file-advisory-text"></span>
    `;
    parent.appendChild(pill);
  }
  const textEl = pill.querySelector('.file-advisory-text');
  if (show && text) {
    if (textEl) textEl.textContent = text;
    pill.hidden = false;
  } else {
    pill.hidden = true;
  }
  return pill;
}
export { trackEvent } from '../core/analytics.js';
